import React from 'react';
import { get } from 'lodash';
import AbstractFopContainer from 'apps/catalogue/components/AbstractFopContainer';
import FopList from 'apps/fops/containers/FopList';
import FeaturedFopElementsFactory from 'apps/fops/components/fopElementsFactories/FeaturedFopElementsFactory';
import HorizontalScrollList from 'apps/catalogue/components/HorizontalScrollList';
import { VIEW_TYPE_PREFERENCE_SHELF } from 'apps/catalogue/actions/catalogue';

class RelatedFopsContainer extends AbstractFopContainer {
  componentDidUpdate(prevProps) {
    if (prevProps.fopCollection.id !== this.props.fopCollection.id) {
      this.horizontalScroll.resetUI();
    }
  }

  render() {
    const {
      betaFeatures,
      productsBySku,
      fopCollection,
      basket,
      productWarnings,
      containerType,
      gtmPageType,
      skipAnalytics,
    } = this.props;

    const relatedFopElementsFactory = new FeaturedFopElementsFactory({
      basketItems: basket.items,
      betaFeatures,
      productsBySku,
      onQuantitySubmit: this.onQuantitySubmit,
      viewTypePreference: VIEW_TYPE_PREFERENCE_SHELF,
      containerType,
    });

    return (
      <HorizontalScrollList
        mainClassName="bop-fops"
        arrowLeft={<span className="icon icon__chevron-left bop-fops__arrow" />}
        arrowRight={<span className="icon icon__chevron-right bop-fops__arrow" />}
        ref={(ref) => { this.horizontalScroll = ref; }}
      >
        <FopList
          sections={[fopCollection]}
          skipAnalytics={skipAnalytics}
          maxDisplayFops={10}
          totalFops={get(fopCollection, 'fops.length')}
          productsBySku={productsBySku}
          productWarnings={productWarnings}
          fopElementsFactory={relatedFopElementsFactory}
          gtmPageType={gtmPageType}
        />
      </HorizontalScrollList>
    );
  }
}

export default RelatedFopsContainer;
